import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {GammaEffectObject} from '@PosterWhiteboard/items/image-item/gamma-effect.class';
export function useGetKeyFromGammaOfActiveItem<T extends keyof GammaEffectObject>(key: T): GammaEffectObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'effects' in item && 'gamma' in item.effects && item.effects.gamma[key] !== undefined) {
      return item.effects.gamma[key];
    }

    return undefined;
  });
}
